import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

interface TvKpiTileProps {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  accentColor: string;
}

/** Big glowing KPI tile for the TV display — the "wow" counterpart to StatCard, sized and lit for
 * viewing from across a room instead of at a desk. */
export default function TvKpiTile({ label, value, icon, accentColor }: TvKpiTileProps) {
  return (
    <Box
      sx={{
        height: '100%',
        borderRadius: '12px',
        borderLeft: `5px solid ${accentColor}`,
        bgcolor: alpha('#ffffff', 0.04),
        backdropFilter: 'blur(6px)',
        px: 3,
        py: 2.5,
        boxShadow: `0 0 28px ${alpha(accentColor, 0.28)}, inset 0 0 0 1px ${alpha('#ffffff', 0.06)}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        {icon ? (
          <Box sx={{ color: accentColor, display: 'flex', fontSize: 28, '& svg': { fontSize: 28 } }}>{icon}</Box>
        ) : undefined}
        <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.65)', letterSpacing: 1.5, fontWeight: 700 }}>
          {label}
        </Typography>
      </Stack>
      <Typography sx={{ mt: 0.5, fontSize: { xs: '2rem', md: '2.75rem' }, fontWeight: 800, lineHeight: 1.1, color: '#fff', textShadow: `0 0 18px ${alpha(accentColor, 0.5)}` }}>
        {value}
      </Typography>
    </Box>
  );
}
